import { applyFilters } from 'snippets/plp-native/@store'
import clsx from 'clsx'

function PlpNativeFilterType({ type, totalResults, filterType, setFilterType }) {
  const searchTypeText = {
    product: 'Products',
    article: 'Blogs',
    page: 'Pages'
  }

  const handleApplyFilters = () => {
    applyFilters({
      searchType: type,
      selectedValues: {}
    })
    setFilterType(type)
  }

  return (
    <button
      type="button"
      className={clsx(
        'text-xs text-neutral-900 font-extrabold [&.active]:underline [&.active]:underline-offset-4',
        filterType === type && 'active'
      )}
      onClick={handleApplyFilters}
    >
      {searchTypeText[type] || 'Results'} ({totalResults})
    </button>
  )
}

export default PlpNativeFilterType
